module.exports = __webpack_public_path__ + "1d0e4c40a0f70b8f5c71c884cfda85bb.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/overalls-denim-s.png
// module id = 1975
// module chunks = 0